import { db } from "../../../firebaseConfig";
import { setDoc, doc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

const arrayToIndexedObject = (arr = []) => {
  const out = {};
  (Array.isArray(arr) ? arr : []).forEach((item, i) => {
    out[i] = item;
  });
  return out;
};

const writeDataS1 = async (formData) => {
  const userId = getSelectedUid();
  if (!userId) throw new Error("Invalid user.");

  try {
    // 1) Personal Details
    const personalRef = doc(db, "Advisers", userId, "Personal Details", "Data");
    await setDoc(
      personalRef,
      {
        ...formData.personalDetails,
        recruitmentUpdates: [
          {
            date: new Date(),
            update: "Pending",
            description: "Not yet submitted",
          },
        ],
      },
      { merge: true },
    );

    // 2) Application Details
    const applicationRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Data",
    );
    await setDoc(
      applicationRef,
      { ...formData.applicationDetails },
      { merge: true },
    );

    // 3) Previous Addresses (store as numeric keys: 0,1,2...)
    const prevAddressRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Previous Addresses",
    );

    await setDoc(
      prevAddressRef,
      arrayToIndexedObject(formData.previousAddress || []),
      {
        merge: true,
      },
    );

    // 4) Next of Kin
    const nokRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Next of Kin Details",
    );

    await setDoc(nokRef, { ...formData.nextOfKinDetails }, { merge: true });
  } catch (error) {
    // console.error("Error writing Section 1:", error);
  }
};

export default writeDataS1;
